angular
  .module('contrast.factory.organization.alert', [])
  .factory('OrganizationAlertFactory', function ($http, UserService) {
    return {
      getAlerts: function () {
        return $http.get(UserService.buildAPIUrl('/orgalerts'))
      }
    }
  })
